import { render, staticRenderFns } from "./EditGpdata.vue?vue&type=template&id=36738aa0"
import script from "./EditGpdata.vue?vue&type=script&lang=js"
export * from "./EditGpdata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports